import React, { useEffect, useState } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import FiltterLead from "./FiltterLead";
import { agentColumns } from "../../tables/agentColumns";
import { agentLeadColumns } from "../../tables/agentLeadColumns";
import AdminDataTable from "../../components/common/AdminDataTable";
import LeadRemark from "./LeadRemark";
import { agentPendingApprovalLeadColumns } from "../../tables/agentPendingApprovalLeadColumns";
import { can } from "../../utils/can";

export default function ViewApprovalLead() {
  const PAGE_SIZE = 10;
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [listLoading, setListLoading] = useState(false);
  const token = localStorage.getItem("adminToken");
  const [leads, setLeads] = useState([]);
  const [filters, setFilters] = useState({});
  const [isRemarkOpen, setIsRemarkOpen] = useState(false);
  const [selectedRemarks, setSelectedRemarks] = useState([]);

  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  const baseName = window.location.pathname
    .split("/")
    .filter(Boolean)
    .pop();

  const fetchLeads = async (
    pageIndex = 0,
    appliedFilters = filters
  ) => {
    setListLoading(true);
    try {
      const pageNumber = pageIndex + 1;

      const queryParams = new URLSearchParams({
        page: pageNumber,
        limit: pageSize,
        sortBy,
        sortOrder,
        ...appliedFilters,
      }).toString();


      const url = `${API_URL}/api/admin/pending-member-lead/${baseName}?${queryParams}`;

      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Authorization": `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      });

      if (!response.ok) {
        throw new Error("Failed to fetch leads");
      }

      const data = await response.json();
      setLeads(data.data);
      setTotalPages(data.pagination.totalPages);

      setListLoading(false);
    } catch (error) {
      console.error("Error fetching leads:", error);
      setListLoading(false);
    }
  };

  const handleDelete = (id) => {
    // Handle delete action
  };

  const pendingToApproval = async (row, status) => {
      if(can("agent_pending_approval_leads", "edit") === false) {
        alert("You don't have permission to update lead status.");
        return;
      }
      
  try {
    
    const queryParams = new URLSearchParams({
      userId: row._id,
      converted_status: status
    }).toString();

    const url = `${API_URL}/api/admin/pending-lead-approve-agent/${baseName}?${queryParams}`;

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Authorization": `Bearer ${token}`,
        "Content-Type": "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Failed to update user status");
    }

    const data = await response.json();

    fetchLeads(); 
  } catch (error) {
    console.error("Error updating user status:", error);
  }
};


  

  const columns = agentPendingApprovalLeadColumns({
    handleDelete,
    PAGE_SIZE,
    pendingToApproval,
  });

  useEffect(() => {
    fetchLeads(page - 1, filters);
  }, [page, pageSize, sortBy, sortOrder]);

  const handleFilter = (newFilters) => {
    setFilters(newFilters);
    setPage(1); // reset page
    fetchLeads(0, newFilters);
  };

  const handleSort = (column) => {
    if (!column) return;

    if (sortBy === column) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(column);
      setSortOrder("asc");
    }
  };

  return (
    <div class="container body">
      <div class="main_container">
        <Sidebar />
        <Header pageTitle="View Pending Approval Lead" />
        {/* page */}
        <div className="right_col" role="main">
        
          {/* /top tiles */}
          {/* body card start */}
          <div className="x_panel">
            <div className="x_title">
              <h2>List  </h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>

              </ul>
              <div className="clearfix" />
            </div>
            <div className="x_content">
              <div className="row">
                <div className="col-sm-12">
                  <FiltterLead onFilter={handleFilter} />
                  {/* filter end */}

                  <AdminDataTable
                    columns={columns}
                    data={leads}
                    page={page}
                    pageSize={pageSize}
                    totalPages={totalPages}
                    loading={listLoading}
                    onPageChange={setPage}
                    onPageSizeChange={(size) => {
                      setPageSize(size);
                      setPage(1);
                      fetchLeads(1, size);
                    }}
                    sortBy={sortBy}
                    sortOrder={sortOrder}
                    onSort={handleSort}
                  />
                </div>
              </div>
            </div>
          </div>
          
        </div>
        {/* page end */}
        <Footer />

      </div>
    </div>
  );
}